export default __webpack_public_path__ + "static/media/join_us_m.b3cdd6ef.jpg";